export const STATE_SELECT_LIST = 'stateSelectList'
export const META_STATE_AND_TYPE_SELECT_LIST = 'MetaStateAndTypeSelectList'
export const CODESET_SELECT_LIST = 'CodesetSelectList'
